import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
/** @jsx jsx */

import { jsx } from '@emotion/core';
import { intrinsic, iframe } from './styles';
export function YouTube(props) {
  return jsx("div", Object.assign({
    css: intrinsic,
    className: "has-iframe"
  }, process.env.ENV_RAW ? null : props.uiEvents), jsx("iframe", {
    css: iframe,
    title: "Youtube video",
    frameBorder: "0",
    src: "https://www.youtube.com/embed/" + props.embedId + "?autoplay=" + (props.autoplay ? 1 : 0),
    allow: "autoplay,fullscreen",
    allowFullScreen: true
  }), props.children);
}